import React from "react";
import { Button, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getAccepted, getHidden } from "../../redux/selectors";
import { toggleHidden } from "../../redux";
import EyeIcon from "remixicon-react/EyeLineIcon";
import EyeOffIcon from "remixicon-react/EyeOffLineIcon";
import { iconSize } from "../../config";

const ToggleHiddenButton = () => {
  const dispatch = useDispatch();
  const hidden = useSelector(getHidden);
  // In order for this button to be active algorithm must output coordinates and they must be within bounds
  const disabled = !useSelector(getAccepted);
  const handleClick = () => {
    dispatch(toggleHidden());
  };
  const icon = hidden ? (
    <EyeOffIcon size={iconSize} />
  ) : (
    <EyeIcon size={iconSize} />
  );
  return (
    <Tooltip
      title={
        disabled ? null : ( //this is a work around disabled prop being broken
          <span>
            {hidden ? "Show" : "Hide"} hotspot on this frame <br></br>(
            <kbd style={{ marginLeft: 0 }}>SPACE</kbd> or click hotspot marker)
          </span>
        )
      }
    >
      <Button
        icon={icon}
        onClick={handleClick}
        onPointerDown={(e) => e.stopPropagation()}
        type="text"
        disabled={disabled}
      />
    </Tooltip>
  );
};

export default ToggleHiddenButton;
